import React, { useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { MarketOverview } from "./MarketOverview";
import { WatchlistManager } from "./WatchlistManager";
import { useWatchlist } from "../../hooks/useWatchlist";
import { useMarketOverview } from "../../hooks/useMarketOverview";

export const MarketDashboard: React.FC = () => {
  const { watchlists, loading: watchlistLoading } = useWatchlist();
  const { marketOverview, loading: overviewLoading } = useMarketOverview();
  const [selectedWatchlistId, setSelectedWatchlistId] = useState<string | null>(
    null,
  );

  React.useEffect(() => {
    if (watchlists.length > 0 && !selectedWatchlistId) {
      setSelectedWatchlistId(watchlists[0].id);
    }
  }, [watchlists, selectedWatchlistId]);

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Market Dashboard
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <MarketOverview data={marketOverview} loading={overviewLoading} />
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <WatchlistManager
            watchlists={watchlists}
            selectedWatchlistId={selectedWatchlistId}
            onSelectWatchlist={setSelectedWatchlistId}
            loading={watchlistLoading}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
